/* eslint-disable */
import '@/js/mobile/globalIncludes';
import '@/js/mobile/globalComponents';

import { viewModelDecorator, propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';

@viewModelDecorator({
    defaults: {
		hideHeader: true
	}
})
@propsDecorator({
    bindings: {
		'.ui-header--flex': 'classes: { "ui-header--nobg": hideHeader }',
		'.ui-header--flex div.text': 'classes: { "text--show": not(hideHeader) }',
	},
})
export default class StaticPage extends Backbone.Epoxy.View {
	initDOMEvents() {
		$(document).scroll(this.calculatePosition.bind(this));
	}

	calculatePosition() {
		const scrollTop = $(window).scrollTop();
		// this is for iphone X 
		// negative scroll prevent mutations
		if (scrollTop < 0) {
			window.scrollTo(0, 1);
			return;
		}
		this.viewModel.set('hideHeader', scrollTop < this.scrollTopPosition);
		this.scrollTopHandler(scrollTop);
	}

	scrollTopHandler() {
		// abstract method
	}

	initialize({ scrollTopPosition = 35 }) {
		this.scrollTopPosition = scrollTopPosition;
		this.initDOMEvents();
    }
}